<div class="event-form-wrap">
    <ig-row>
        <ig-col [xs]="12">
            <ig-hub-create-event></ig-hub-create-event>
        </ig-col>
    </ig-row>
    <ig-row>
        <ig-col [xs]="12">
            <ig-hub-create-place></ig-hub-create-place>
        </ig-col>
    </ig-row>
</div>place


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/manually.add/manually.add.component.html